import { memo, useRef } from 'react'
import { getUniqueId } from 'lib/util/uniq'
import styles from './SiteBorder.module.scss'
import BorderBase from './components/BorderBase/BorderBase'
import BorderCorner from './components/BorderCorner/BorderCorner'

/**
 * The `HUD` component is used for rendering
 * a decorative visual border around the entire viewport
 *
 * @param props
 * @returns {React.ReactElement} the element
 */
function SiteBorder (props) {
  const uid = useRef(getUniqueId())

  return (
    <div
      className={styles.border}
      style={{ '--corner-clip': `url(#hud-corner-clip-${uid.current})` }}
      aria-hidden="true"
    >
      <BorderCorner clipId={`hud-corner-clip-${uid.current}`} />
      <BorderBase />
    </div>
  )
}

// Memoize
export default memo(SiteBorder)
